import React, { Component } from 'react';
//import { Grid, Row, Col } from 'react-bootstrap';
//import './Footer.css'
import SimplifiedLayout from '../SimplifiedLayout.js';
import Helmet from 'react-helmet';

class Terms extends Component {
	render() {

		return (
			<div>

			<Helmet title="Terms"/>
                <SimplifiedLayout fixedNavbar={true}>

<div className="container">

<h1>Terms of Service</h1>

<p>Welcome to the Terms and Conditions Page of webfinery.com.</p>

<p>The terms and conditions being
described on this Page will govern all issues that may arise in relation to
your access to <a href="https://webfinery.com">webfinery.com</a> (referred
as Webfinery) or use of any feature, social media, application, visitor
notification, user data, and business promotion campaigns or related services
being offered/provided by Mint Rock Limited (collectively referred as the
Service). Please review these terms and conditions before accessing this
website or using the Service being offered on this website or other websites
being owned and operated by Mint Rock Limited (referred as Mint Rock). If you
have any reservations or not satisfied with these terms and conditions at all,
you may stop accessing Webfinery and discontinue all the Services being offered
by Mint Rock.</p>

<h2>Agreement</h2>

<p>Access to webfinery.com shall be
voluntary but the Service shall be made available to only the registered users
of Webfinery. All users, including the guest users, shall enter a legally
binding agreement with Mint Rock for accessing this website or using the
Service being offered on webfinery.com or other websites being owned and
operated by Mint Rock. Electronic acceptance or digital signature will be
sufficient to create a legally binding agreement, consisting of these terms and
conditions, and clicking I Agree or related syntaxes or links on any part of
this website or the interface of your devices will bind you to this agreement.
Accessing webfinery.com or using the Service shall be deemed as your express
consent to enter and abide by this agreement.</p>

<p>When you access webfinery.com or
use the Service, it shall be deemed that you are legally mature and qualified
to enter this agreement, and if not, accessing this website or using the
Service under the supervision/guidance of your legal guardians, who shall
consent to enter this agreement on your behalf. If you are entering this
agreement on behalf of any company or organization, it shall be deemed that you
are duly authorized to represent the company/organization, and if you are not,
take your personal responsibility to fulfill all your obligations under this
agreement.</p>

<p>This agreement shall be deemed as
part of your Entire Agreement with Mint Rock, including but not limited to the
Privacy Policy, User licenses, Refund Policy and additional agreements that you
may enter for using any feature or service being offered on webfinery.com. </p>

<p>These terms and conditions will
apply in its entirety, and you will not be allowed to redefine the terms of
this Agreement by selecting specific terms. If there is any inconsistency
between this agreement and other licenses or additional agreements, the
relevant provisions of this agreement shall prevail. However, if any kinds of inconsistency/discrepancy
occur due to relevant laws or enacted legislation, the local, state or federal
laws shall prevail to the extent of such discrepancy.</p>

<p>All matters arising out of your
access to webfinery.com or use of the Service being made available on this
website shall be governed by these terms and conditions, but nothing in this
agreement shall protect the contracting parties from the legal implications of
fraud/unauthorized activities on webfinery.com, or illegal use of the Service.
Accessing this website or using any service, in whole or parts thereof, without
entering this agreement shall be deemed as unauthorized access/activity.</p>

<p>Mint Rock reserves a right to
determine the process and procedures of subscription/membership to the website
or use of the Service being made available on webfinery.com. However, nothing on
this website, including the process and procedures, guidelines, advice,
recommendations, suggestions and support tendered by Mint Rock executives or
its authorized representatives shall create any kinds of warranties,
representations or obligations unless it has been mentioned in this agreement. </p>

<p>Mint Rock reserves a right to monitor
and record your activities on webfinery.com or any accessible sections of the
website or the Service being provided/sponsored by Mint Rock or its collaborating
partners (referred as Mint Rock Partners). If Mint Rock believe or become aware
at any point that you have violated any provision of this agreement/relevant
laws, it may block your access to webfinery.com, suspend / terminate your
subscription, and prevent any further use of the Service. In such cases, it
shall be deemed that you have authorized Mint Rock to take proactive measures
and disclose any information, content, recorded messages or communications to
relevant authorities / third parties in its sole discretion.</p>

<p>It shall be your responsibility
to ensure that you are authorized to access this website or use the Service in
your home country, and by doing so, you are not violating any local, state or
federal laws.</p>

<p>You should acknowledge and consent
that Mint Rock shall be entitled to protect its business/legal rights and
ensure that the rights of its users and Mint Rock Partners are not violated.</p>

<h2>Registration / Subscription</h2>

<p>Access to webfinery.com shall be
voluntary but only subscribed/registered users shall be allowed to use the
Service. You may be required to submit your profile information like name, age,
location, email address, company name and payment details for creating an
account on this website or subscribing to any service being made available by
Mint Rock or the Mint Rock partners. Creating an account or subscribing to any
service on the website shall be deemed as your consent to provide an accurate,
complete and updated information/user profile.</p>

<p>You shall warrant that:</p>
<ul>
<li>
The submitted information is true, accurate, current and complete
in your knowledge, and you will promptly update your profile information when
any changes occur.
</li>
<li>
You will comply with this agreement.
</li>
</ul>
<p>
You are creating an account / uploading your profile information
on the website solely for using the Service being provided by Mint Rock.</p>

<p>Mint Rock reserves a
discretionary right to verify your name, company name, email address, cell
phone number or other credentials before authorizing your account or allowing
you to use the Service. Once your credentials are verified, you shall be allowed
use the Service as a member of Webfinery. </p>

<p>If Mint Rock believes or becomes
aware at any point that the submitted information is inaccurate, fabricated,
outdated or incomplete, and you are trying to create a fabricated/impersonated
account on this website for suspected reasons/purposes, it may
suspend/terminate your Account in its sole discretion and prevent any further
use of the Service.</p>

<p>You will be responsible for
maintaining the confidentiality of your account username and password. You
shall be liable for all activities that take place under your credentials. Therefore,
if you suspect any kinds of unauthorized access to your account, promptly
contact our support executives to prevent any further misuse of your account. Mint
Rock shall not be liable for any loss or damage from unauthorized access to
your account or use/misuse of your personal information due to your failure to
maintain the confidentiality of your login information.</p>

<h2>Subscription fee and Payment</h2>

<p>Authorized account holders will
be allowed to purchase any subscription packages being offered on webfinery.com.
The subscribers shall be allowed to opt for a monthly or yearly subscription.
The monthly subscription fee will be charged every month while yearly
subscription will be charged once in a year on a recurring basis. The
subscribed packages will be auto renewed unless the users give a 30 daysÕ
notice to terminate / end their subscription with Webfinery. Mint Rock
reserves a right to offer special discounts and promotional offers from time to
time.</p>

<p>The subscriberÕs payment
instruments / credit cards shall be charged within seven days of their due
date. If the subscribers are unable to pay their due amount within the
stipulated seven days, Mint Rock reserves a right to deactivate/terminate the
Service without giving any prior notice for such deactivation / termination.</p>

<p>No refund or claims shall be
entertained on the grounds that your account was deactivated / terminated
before the expiry of the subscribed period and you shall be liable for all your
pending obligations prior to such deactivation/termination.</p>

<h2>Cancelation of the Subscription</h2>

<p>Mint Rock reserves a right to
refuse any request for subscription, cancel your subscription or delete the
account of any subscriber on webfinery.com in its sole discretion and without
any prior notice for such cancelations.</p>

<p>The subscribers should also be
allowed to cancel their subscription, but 30 days prior notice shall be
necessary for such cancelations. If you decide to cancel your subscription and
give a minimum 30 daysÕ notice to cancel your subscription, the remaining
subscription periods shall be charged and become due on the date of such cancelation.</p>

<p>Once your subscription is canceled,
you shall be obligated to discharge all your dues under this agreement. All
your reports, account information, historical data will be permanently deleted.</p>

<h2>Taxes and Duties</h2>

<p>The U.K. users /subscribers
should be liable to pay applicable taxes, duties and levies, including VAT
charges on the subscription fee or use of the Service.</p>

<p>No taxes will be charged from the
EU subscribers, provided that they have submitted their valid TAX ID. Failure
to submit a valid TAX ID will result in VAT and other charges as applicable.</p>

<p>No taxes will be charged from the
subscribers from the rest of the world and they are not required to submit
their TAX IDs.</p>

<p>If your payment instrument /
credit card fails due to any reasons, the subscription dues will be rebilled /
charged on a periodic basis.</p>

<h2>Copyright and Trademarks</h2>

<p>All texts, images, icons,
graphics, logos, page headers, scripts, user interface, and the entire
presentation on the webfinery.com, including the content, applications,
services, service names are owned by Mint Rock, and fully protected under the Copyright,
Designs and Patents Act. You should never copy or transfer the contents in any
form or by any means to edit, modify, alter, publish, sell, lease, reproduce,
redistribute, repost or use in any form, in whole or parts thereof, without a written
permission from Mint Rock and/or Mint Rock Partners/Service Providers. Unless
otherwise specified in this agreement, nothing on this website, whether stated
or implied, shall confer you any kinds of license or rights over the
copyrighted content/materials being made available on webfinery.com or other
websites being owned and operated by Mint Rock.</p>

<p>All content / information or the
Service being made available on the website shall be intended for information
purposes only. You may access/download a single copy of shared content for
personal use, but all kinds of commercial use, including but not limited to
copying, reproduction, and redistribution of any material or design element of Mint
Rock and its featured services shall be strictly prohibited, unless you have a
written permission from Mint Rock.</p>

<p>Nothing on this website shall
grant you any rights to edit, alter or remove the logos, copyright information,
trademarks, and other proprietary notices from the downloaded content or on any
parts of the website. You will have no rights to systematically retrieve user
data or other content from the website, or use any known or unknown technology
to create / compile its database, directory, and archives in any form or manner
without a written permission from Mint Rock.</p>

<p>You should acknowledge that all
logos, trademarks, trade names, design, presentation and service names belong
to Mint Rock or Mint Rock Partners / Service Providers, and fully protected by
the copyright and trademark laws. You should always respect the logos and
trademarks on this website. Nothing in this agreement, whether stated or
implied, shall grant you any right/license to use the trademarks of Mint Rock or
its Service Providers.</p>

<h2>Content ownership</h2>

<p>Nothing on this website shall
grant you any kind of ownership or copyrights over the shared material or
content, regardless of your rights to access or download such scripts, reports
or data while using the Service. Unless otherwise mentioned in this agreement,
you shall never be allowed to edit, change or counterfeit any copyrighted
material, including the scripts, reports, website reviews or any other content
that you might download while using the Service. Although you are entitled to
access / download a single copy of shared / sublicensed content for personal
and non-commercial use, this user right should never be interpreted as any
kinds of ownership rights. </p>

<p>When you participate in forums,
social media platforms or publicly accessible sections of this website, Mint
Rock shall be entitled to a perpetual, irrevocable and royalty-free rights to
all the user-generated content or materials, including but not limited to
suggestions, enhancements, requests, feedback or recommendations that may be
published, communicated or shared on webfinery.com, or the forums and social
media platforms being supported / sponsored by Mint Rock. Mint Rock reserves
unlimited rights to modify, distribute, transfer or share the posted /
published content with the third parties.</p>

<h2>Compliance</h2>

<p>All kinds of unlawful activities
on webfinery.com shall be strictly prohibited. You should follow the applicable
laws, rules and regulations, and never use the Service in such a manner or for
a purpose that infringes upon third party rights, including their rights
regarding intellectual property, copyrights, trademarks, trade secrets and
other proprietary rights or leads to unfair competition, misleading
advertising, defamation or invasion of anybodyÕ right to privacy or publicity.</p>

<h2>Termination of the Service</h2>

<p>Subject to the provisions for
canceling a subscription, the parties shall be allowed to terminate this
agreement at any time without the need to convey the other party about the
reasons for such termination.</p>

<p>If Mint Rock believes or becomes
aware that you have removed its scripts from your website, or violated any
provisions of this agreement and relevant laws, it may immediately suspend your
access to the Service or permanently terminate this agreement.</p>

<p>If this agreement is terminated
due to any reasons:</p>
<ul>
<li>Mint Rock will prevent you from using the Service any further
</li>
<li>You will be obligated to purge all copies of scripts, reports or
downloaded content from your web pages.
</li>
<li>You will be required to immediately discharge your pending financial
obligations under this agreement.
</li>
<li>No claims for a refund will be entertained. Paid subscriptions shall
remain non-refundable.
</li>
<li>You will not be entitled to receive any kinds of historical report or
data.
</li>
</ul>

<p>Keeping the scripts on your
website after the termination of this agreement shall constitute an
unauthorized use of the Service as it will consume the resources on webfinery.com.
Mint Rock reserves a right to take all the necessary measures to force your
compliance and recover the legal or administrative costs involved in such
actions</p>

<h2>Indemnification</h2>

<p>You shall indemnify, hold
harmless and defend Mint Rock and its collaborating partners, subsidiaries,
affiliates, service providers, agents, executives and employees against all
losses, damages, liabilities, actions, proceedings, suits, settlements,
penalties, fines, costs, expenses or claims, including but not limited to legal
fees and administrative charges that may arise due to:</p>
<ul>
<li>Your access to webfinery.com or use of the Service being offered on the
website.
</li>
<li>Your violation of this agreement or applicable laws.
</li>
<li>Your violation or infringement of third party rights, including the rights
of Mint Rock Partners or other subscribers.
</li>
<li>Your use or misuse of the Service, including the applications, forums,
social media platforms, and other value added features, information, business
promotion strategies or services being offered on this website.
</li>
</ul>

<p>When any such claim, suit or
action in relation to your indemnification occurs, Mint Rock will take
appropriate measures to inform you and you will be liable to defend all such
claims and liabilities at your own expense. However, Mint Rock reserves a right
to directly defend such claims and charge all fees and legal expenses that may
arise in defending any subject matter indemnified by you.</p>

<h2>Disclaimer of Warranties</h2>

<p>The disclaimer of warranties will
constitute an essential part of this agreement. Subject to your rights under
the applicable laws, Mint Rock disclaims all conditions and warranties to the
fullest extent possible, including but not limited to the express or implied
warranties of performance, business promotion, accuracy, reliability, and suitability
for your business or non-infringement of proprietary rights.</p>

<p>Subject to your Non-excludable
Rights, you should acknowledge that:</p>

<ul>

<li>
The Service, including the scripts, reports and business promotion
strategies are being offered <em>as it is</em> and <em>as available</em> criteria without
creating any kinds of express, implied or statutory representations or
warranties regarding the quality, performance, business promotion or
merchantability, course of dealings, course of performance, trade or usage.
</li>

<li>
Mint Rock will not be liable for any fraudulent subscriber or companies that
pretend to be credible members of Webfinery but engage in unsolicited behavior or
activities. Nothing on the website shall make Mint Rock responsible for the
behavior/activities of subscribers and the third parties.
</li>

<li>
You will bear all the risks that may be involved in accessing the
Service over the Internet. Mint Rock will not be liable for any kinds of
unauthorized access to your account, misuse of credit card information,
identity theft or infringements of your rights that might take place on webfinery.com
or the websites being owned and controlled by Mint Rock.
</li>

<li>
Nothing on the website will create any kinds of implicit or explicit
guarantee that the Service will perform to your expectations, defects or errors
will be corrected quickly, interruptions will be restored promptly, and/or the
downloaded content will be free from viruses or malicious codes.
</li>

<li>
Nothing on this website shall create any kinds of implicit or explicit
warranty or representation regarding your access to webfinery.com and the
accuracy, reliability, availability, suitability, timeliness or completeness of
the content, information, scripts, analysis and reports, business promotion
strategies or other services being featured, published or provided on
webfinery.com.
</li>

<li>Nothing on this website shall create any kinds of implicit or explicit
guarantee or assurance that you are legally allowed / qualified to use the
Service in your country. It shall be your responsibility to ensure that you are
legally entitled to use the Service in your country.</li>

<li>Nothing on this website shall create any kinds of implicit or explicit
guarantee or representation that scripts, reports, website analysis, business
promotion strategies and other services being featured /offered on this website
are reliable or suitable for your website/business. The content on this website
shall be deemed for information purpose only. You should carefully review the
scripts, reports, website analysis, and business promotion strategies before
using any service being offered on the website. Mint Rock shall not be liable
for any non-performance or adverse consequences that may result from using the
Service, irrespective of the advice, suggestion or recommendations on the
website. </li>

</ul>


<h2>Limitation of Liabilities</h2>

<p>Mint
Rock shall not be liable to you or third parties for any direct, indirect,
minor, major, punitive, incidental, consequential, exemplary or special
damages, including but not limited to financial losses, low profits, loss of
goodwill, data, credibility or other intangible losses that may arise in
relation to your ability or inability to use the website or the scripts, links,
reports, business promotion strategies, advice, suggestions, recommendations, promises
and/or other services due to interruption, suspension, modification or
termination of the Service, negligence of duty, or breach of contract, statutory
duty, indemnity, contribution, or strict liability on part of the Mint Rock or
otherwise, irrespective of the fact that the possibility of such damages and
liabilities was already conveyed to Mint Rock.</p>

<p>Some
jurisdictions do not allow such limitation of liabilities. In such
jurisdictions, some of the foregoing limitations may not apply to you. However,
in such cases, the total liabilities of Mint Rock and its collaborating
partners shall never exceed the total subscription amount that you paid for
using the Service or £250, whichever is less.</p>

<p>You should acknowledge that Mint
Rock doesn't supervise, monitor or control the communications between the subscribers
that take place on forums, social media platforms and publicly accessible
sections of the website. Therefore, you shall consent to:</p>
<ul>
<li>Indemnify Mint Rock and its collaborating partners, and hold them
harmless against all known or unknown claims, damages or consequences that may
arise in relation to your access to the forums, social media platforms,
publicly accessible sections of the website or use of the Service.
</li>
<li>Waive your non-exclusion rights and benefits that are available in your
jurisdiction and limit the scope of this release / waiver, irrespective of
their statutory or non-statutory nature.
</li>
<li>Give up your special rights / benefits that you have or may have as a
California resident or granted under the similar civil codes, laws, and
regulations for being a resident of certain jurisdictions. You shall relinquish
your rights / benefits to the fullest extent that you may lawfully waive.
</li>
</ul>

<p>All statements, opinion, views,
reviews, recommendations, suggestions, or other communications that take place
in the forums, social media platforms, message boards, conferences, chat rooms,
newsgroups, emails and other accessible sections of this website shall be
deemed as non-confidential. You should acknowledge that the subscribers, forum
hosts, content providers, and Mint Rock Partners are not the authorized
spokespersons of Webfinery, and their views donÕt reflect its official opinion
or endorsement.</p>

<h2>Third Party Websites</h2>

<p>Webfinery may include links and
ads to third party websites and their content. These links / ads are
incorporated for providing useful views, reviews, information and services
related to marketing and business promotion. You should acknowledge that third
party websites operate under their own terms and policies, and Mint Rock has no
role in controlling their terms or data collection practices, irrespective of
their collaboration/affiliation status with Webfinery.</p>

<p>Mint Rock will take appropriate
measures to protect the integrity of this website, but you shall bear all the
risks that may be involved in accessing/using third party websites. You should
carefully review the terms and conditions of these third party websites before
using any service or content being offered by them.</p>

<h2>Privacy Policy</h2>

<p>When you access webfinery.com or
use the Service being offered on this website, Mint Rock may collect and use
your personal information. However, a Privacy Policy will be maintained as a
part of this agreement, and all kinds of data collection, processing, storage,
use or sharing of your personal information will be governed by this privacy
policy.</p>

<p>However, nothing in this Privacy
Policy will apply to your personal information that you share on the forums,
social media platforms and publicly accessible sections of the website. Mint
Rock reserves a right to use our shared profile data or information for its
business promotion.</p>

<h2>Notices</h2>

<p>All electronic disclosures,
notices and communications in matters related to your access to webfinery.com or
use of the Service being offered on this website or made available by Mint Rock
Partners will take place in digital format, retaining the same legal sanctity
as on communicated in writing.</p>

<h2>Jurisdiction</h2>

<p>The provisions of this agreement
shall be governed by the U.K. laws and the parties to this agreement shall
consent to submit to the exclusive jurisdiction of the English courts. All
matters in relation to your access to this website or use of the Service,
unless resolved through mutual negotiations, shall be decided by the courts in
the U.K. The English version of this agreement shall be deemed as the original
agreement. Webfinery may provide translated versions of this agreement, but in
the case of any discrepancy between the English and translated versions, the
provisions of the English version shall prevail.</p>

<h2>Severability</h2>

<p>If any provision of this
agreement becomes redundant or declared void by the courts with competent
authority, the affected provisions / sections shall be replaced by new terms in
the true spirit of impugned clause/sections, and the remaining provisions shall
remain unaffected.</p>

<h2>Changes to this Agreement</h2>

<p>Mint Rock shall be entitled to
modify or replace these terms and conditions at any time without giving any
prior notice for such modifications. When any changes occur, it will take
appropriate measures to notify its subscribers, but it shall be your
responsibility to keep yourself informed about the policy changes that may take
place over time. Once notified, the modified agreement will replace and
supersede all previous versions of this agreement. The signing of a new
agreement by authorized representatives, digital acceptance of the modified
agreement or the continued use of this website / Service shall be deemed as
your explicit consent to accept the modified agreement. The following
activities will be interpreted as the continued use of the Service:</p>
<ul>
<li>Browsing any page of the website after policy modifications
</li>
<li>Keeping any scripts on your web page or using such scripts after
policy modifications
</li>
<li>Logging into your account after any modifications in this
agreement
</li>
<li>Accessing any data, report or service after such modifications,
whether directly or through any third party service
</li>
</ul>

</div>

	</SimplifiedLayout>
	</div>
        )
	}
}

export default Terms;


// WEBPACK FOOTER //
// ./src/content/Terms.js